"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, X, Package, LogOut, Gift } from "lucide-react";
import { MobileSidebarProps } from "@/components/header/types";
import { getCategories, getStandaloneCategoryLinks } from "@/components/header/nav-utils";
import DrillDownItem from "@/components/header/shared/DrillDownItem";
import { useUser } from "@/contexts/user-context";
import { useLockBodyScroll } from "@/utils/hooks/useLockBodyScroll";
const MobileSidebar: React.FC<MobileSidebarProps> = t0 => {
  const $ = _c(103);
  const {
    setSidebarOpen,
    navigation,
    isNavigationLoading
  } = t0;
  const {
    isAuthenticated,
    logout
  } = useUser();
  let t1;
  if ($[0] !== navigation) {
    t1 = [{
      title: "Main Menu",
      items: navigation
    }];
    $[0] = navigation;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [menuStack, setMenuStack] = useState(t1);
  let t2;
  if ($[2] !== menuStack.length || $[3] !== navigation) {
    t2 = () => {
      if (navigation && navigation.length > 0 && menuStack.length === 1) {
        setMenuStack([{
          title: "Main Menu",
          items: navigation
        }]);
      }
    };
    $[2] = menuStack.length;
    $[3] = navigation;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== navigation) {
    t3 = [navigation];
    $[5] = navigation;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  useLockBodyScroll(true);
  const currentMenu = menuStack[menuStack.length - 1];
  let t4;
  if ($[7] !== menuStack) {
    t4 = (title, items) => {
      setMenuStack([...menuStack, {
        title,
        items
      }]);
    };
    $[7] = menuStack;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handlePush = t4;
  let t5;
  if ($[9] !== menuStack) {
    t5 = () => {
      if (menuStack.length > 1) {
        setMenuStack(menuStack.slice(0, -1));
      }
    };
    $[9] = menuStack;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handlePop = t5;
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] !== currentMenu.items || $[12] !== currentMenu.title || $[13] !== handlePop || $[14] !== handlePush || $[15] !== isNavigationLoading || $[16] !== menuStack.length || $[17] !== setSidebarOpen) {
    const renderMenuItems = items_0 => items_0.map((item, index) => {
      if (item.type === "group") {
        if (!item.title) {
          return <div key={`group-${index}`}>{renderMenuItems(item.items)}</div>;
        }
        return <div key={`group-${index}`} className="mt-6 mb-2"><div className="px-4 text-[11px] font-bold text-gray-400 uppercase tracking-widest">{item.title}</div><div className="mt-2">{renderMenuItems(item.items)}</div></div>;
      }
      const categories = getCategories(item);
      const standaloneLinks = getStandaloneCategoryLinks(item);
      const hasChildren = categories.length > 0 || item.children && item.children.length > 0;
      return <DrillDownItem key={item.id || index} title={item.title || item.heading} url={item.url} hasChildren={hasChildren} isActive={false} onLinkClick={() => setSidebarOpen(false)} onClick={() => {
        let subItems;
        if (item.children) {
          subItems = item.children.map(_temp);
        } else {
          subItems = categories.map(_temp2);
          if (standaloneLinks.length > 0) {
            subItems.push({
              type: "group",
              title: "Other Links",
              items: standaloneLinks
            });
          }
        }
        handlePush(item.title || item.heading, subItems);
      }} />;
    });
    t22 = "fixed inset-0 z-[100] flex";
    let t24;
    let t25;
    let t26;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = {
        opacity: 0
      };
      t25 = {
        opacity: 1
      };
      t26 = {
        opacity: 0
      };
      $[39] = t24;
      $[40] = t25;
      $[41] = t26;
    } else {
      t24 = $[39];
      t25 = $[40];
      t26 = $[41];
    }
    if ($[42] !== setSidebarOpen) {
      t23 = <motion.div initial={t24} animate={t25} exit={t26} className="fixed inset-0 bg-black/60 backdrop-blur-sm touch-none" onClick={() => setSidebarOpen(false)} />;
      $[42] = setSidebarOpen;
      $[43] = t23;
    } else {
      t23 = $[43];
    }
    T2 = motion.div;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = {
        x: "-100%"
      };
      t17 = {
        x: 0
      };
      t18 = {
        x: "-100%"
      };
      t19 = {
        type: "spring",
        damping: 25,
        stiffness: 200
      };
      $[44] = t16;
      $[45] = t17;
      $[46] = t18;
      $[47] = t19;
    } else {
      t16 = $[44];
      t17 = $[45];
      t18 = $[46];
      t19 = $[47];
    }
    t20 = "relative flex flex-col w-full max-w-[320px] bg-white shadow-2xl h-full overflow-hidden overscroll-contain";
    let t27;
    if ($[48] !== handlePop || $[49] !== menuStack.length) {
      t27 = menuStack.length > 1 && <button onClick={handlePop} className="p-2 -ml-2 rounded-full hover:bg-gray-100 transition-colors"><ChevronLeft size={20} className="text-gray-600" /></button>;
      $[48] = handlePop;
      $[49] = menuStack.length;
      $[50] = t27;
    } else {
      t27 = $[50];
    }
    let t28;
    if ($[51] !== currentMenu.title) {
      t28 = <div className="font-plus_jakarta_sans font-bold text-lg text-gray-800 truncate max-w-[180px]">{currentMenu.title}</div>;
      $[51] = currentMenu.title;
      $[52] = t28;
    } else {
      t28 = $[52];
    }
    let t29;
    if ($[53] !== t27 || $[54] !== t28) {
      t29 = <div className="flex items-center gap-x-2">{t27}{t28}</div>;
      $[53] = t27;
      $[54] = t28;
      $[55] = t29;
    } else {
      t29 = $[55];
    }
    let t30;
    if ($[56] !== setSidebarOpen) {
      t30 = () => setSidebarOpen(false);
      $[56] = setSidebarOpen;
      $[57] = t30;
    } else {
      t30 = $[57];
    }
    let t31;
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
      t31 = <X size={20} className="text-gray-500" />;
      $[58] = t31;
    } else {
      t31 = $[58];
    }
    let t32;
    if ($[59] !== t30) {
      t32 = <button onClick={t30} className="p-2 rounded-full hover:bg-gray-100 transition-colors">{t31}</button>;
      $[59] = t30;
      $[60] = t32;
    } else {
      t32 = $[60];
    }
    if ($[61] !== t29 || $[62] !== t32) {
      t21 = <div className="flex items-center justify-between px-4 h-16 border-b border-gray-100 bg-white">{t29}{t32}</div>;
      $[61] = t29;
      $[62] = t32;
      $[63] = t21;
    } else {
      t21 = $[63];
    }
    t15 = "flex-1 overflow-y-auto no-scrollbar relative";
    T1 = AnimatePresence;
    t13 = false;
    t14 = "wait";
    T0 = motion.div;
    t6 = menuStack.length;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        x: 20,
        opacity: 0
      };
      t8 = {
        x: 0,
        opacity: 1
      };
      t9 = {
        x: -20,
        opacity: 0
      };
      t10 = {
        duration: 0.2
      };
      $[64] = t10;
      $[65] = t7;
      $[66] = t8;
      $[67] = t9;
    } else {
      t10 = $[64];
      t7 = $[65];
      t8 = $[66];
      t9 = $[67];
    }
    t11 = "py-2";
    t12 = isNavigationLoading ? <div className="p-4 space-y-4">{[...Array(6)].map(_temp3)}</div> : renderMenuItems(currentMenu.items);
    $[11] = currentMenu.items;
    $[12] = currentMenu.title;
    $[13] = handlePop;
    $[14] = handlePush;
    $[15] = isNavigationLoading;
    $[16] = menuStack.length;
    $[17] = setSidebarOpen;
    $[18] = T0;
    $[19] = T1;
    $[20] = T2;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
    $[30] = t19;
    $[31] = t20;
    $[32] = t21;
    $[33] = t22;
    $[34] = t23;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
  } else {
    T0 = $[18];
    T1 = $[19];
    T2 = $[20];
    t10 = $[21];
    t11 = $[22];
    t12 = $[23];
    t13 = $[24];
    t14 = $[25];
    t15 = $[26];
    t16 = $[27];
    t17 = $[28];
    t18 = $[29];
    t19 = $[30];
    t20 = $[31];
    t21 = $[32];
    t22 = $[33];
    t23 = $[34];
    t6 = $[35];
    t7 = $[36];
    t8 = $[37];
    t9 = $[38];
  }
  let t24;
  if ($[68] !== T0 || $[69] !== t10 || $[70] !== t11 || $[71] !== t12 || $[72] !== t6 || $[73] !== t7 || $[74] !== t8 || $[75] !== t9) {
    t24 = <T0 key={t6} initial={t7} animate={t8} exit={t9} transition={t10} className={t11}>{t12}</T0>;
    $[68] = T0;
    $[69] = t10;
    $[70] = t11;
    $[71] = t12;
    $[72] = t6;
    $[73] = t7;
    $[74] = t8;
    $[75] = t9;
    $[76] = t24;
  } else {
    t24 = $[76];
  }
  let t25;
  if ($[77] !== T1 || $[78] !== t13 || $[79] !== t14 || $[80] !== t24) {
    t25 = <T1 initial={t13} mode={t14}>{t24}</T1>;
    $[77] = T1;
    $[78] = t13;
    $[79] = t14;
    $[80] = t24;
    $[81] = t25;
  } else {
    t25 = $[81];
  }
  let t26;
  if ($[82] !== t15 || $[83] !== t25) {
    t26 = <div className={t15}>{t25}</div>;
    $[82] = t15;
    $[83] = t25;
    $[84] = t26;
  } else {
    t26 = $[84];
  }
  let t27;
  if ($[85] !== isAuthenticated || $[86] !== logout || $[87] !== setSidebarOpen) {
    t27 = isAuthenticated && <div className="p-4 border-t border-gray-100 bg-gray-50/50"><div className="space-y-3"><Link href="/my-orders" onClick={() => setSidebarOpen(false)} className="flex items-center gap-x-3 px-4 py-3 bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all group"><div className="w-8 h-8 rounded-full bg-[#037a6a]/10 flex items-center justify-center group-hover:bg-[#037a6a]/20 transition-colors"><Package size={16} className="text-[#037a6a]" /></div><div className="flex flex-col"><span className="font-serif font-bold text-sm text-gray-700">My Orders</span><span className="text-[10px] text-gray-400 font-medium">Track your recent orders</span></div></Link><button onClick={() => {
          logout();
          setSidebarOpen(false);
        }} className="flex items-center gap-x-3 px-4 py-2 text-gray-400 hover:text-red-500 transition-colors w-full"><LogOut size={16} /><span className="font-serif font-semibold text-xs uppercase tracking-wider">Logout</span></button></div></div>;
    $[85] = isAuthenticated;
    $[86] = logout;
    $[87] = setSidebarOpen;
    $[88] = t27;
  } else {
    t27 = $[88];
  }
  let t28;
  if ($[89] !== T2 || $[90] !== t16 || $[91] !== t17 || $[92] !== t18 || $[93] !== t19 || $[94] !== t20 || $[95] !== t21 || $[96] !== t26 || $[97] !== t27) {
    t28 = <T2 initial={t16} animate={t17} exit={t18} transition={t19} className={t20}>{t21}{t26}{t27}</T2>;
    $[89] = T2;
    $[90] = t16;
    $[91] = t17;
    $[92] = t18;
    $[93] = t19;
    $[94] = t20;
    $[95] = t21;
    $[96] = t26;
    $[97] = t27;
    $[98] = t28;
  } else {
    t28 = $[98];
  }
  let t29;
  if ($[99] !== t22 || $[100] !== t23 || $[101] !== t28) {
    t29 = <div className={t22}>{t23}{t28}</div>;
    $[99] = t22;
    $[100] = t23;
    $[101] = t28;
    $[102] = t29;
  } else {
    t29 = $[102];
  }
  return t29;
};
export default MobileSidebar;
function _temp(c) {
  return {
    ...c,
    title: c.heading
  };
}
function _temp2(cat) {
  return {
    type: "group",
    title: cat.title,
    items: cat.items
  };
}
function _temp3(_, i) {
  return <div key={i} className="h-10 bg-gray-100 rounded-lg animate-pulse" />;
}